export default __webpack_public_path__ + "static/media/imagetwelve.5257c7f8.gif";